import FormBuilder from "@components/reports/FormBuilder";
import ReportsList from "@components/reports/ReportsList";
import ReportsClient from "@api/reports";
import React from "react";
import { Grid, Header, Message, Segment } from "semantic-ui-react";

class ReportsView extends React.Component {
  state = {
    reports: [],
    selectedCategory: null,
    report: { id: null },
    error: null,
    loading: false,
  };

  onSelection = (selection) => {
    this.onParamsChange(selection);
  };

  onError = (error, callback = () => {}) => {
    this.setState({ error }, callback);
  };

  onParamsChange = (
    report,
    params = ["#", "#", "#", "#", "#", "#", "#", "#", "#", "#"],
  ) => {
    this.setState({ error: null, loading: true }, () => {
      ReportsClient.getReport(report.id, params).then(
        (response) => {
          this.setState({
            loading: false,
            report: { ...report, data: response },
          });
        },
        () => this.setState({ loading: false }),
      );
    });
  };

  onFavourite = (item) => {
    const setFn =
      item.isFavourited === 1
        ? ReportsClient.unsetFavourite
        : ReportsClient.setFavourite;

    this.setState({ loading: true }, () => {
      setFn(item.id).then(() => {
        this.setState({ loading: false }, () => {
          this.refresh();
        });
      });
    });
  };

  refresh = () => {
    this.setState({ loading: true }, () => {
      ReportsClient.fetchReports().then(
        (reports) => this.setState({ reports, loading: false }),
        () => this.setState({ loading: false }),
      );
    });
  };
  componentDidMount() {
    this.refresh();
  }

  render() {
    const selectedCategory = this.state.reports.find(
      (x) => x.id === this.state.selectedCategory,
    );

    const { loading } = this.state;

    return (
      <Grid className="mt-2 mb-2" columns="2">
        {this.state.error && (
          <Grid.Row>
            <Grid.Column width="16">
              <Message
                negative
                onDismiss={() => this.setState({ error: null })}
              >
                {this.state.error}
              </Message>
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Column width="3">
            <ReportsList
              reports={this.state.reports}
              selected={selectedCategory}
              loading={loading}
              onSelection={(item) => {
                this.setState({ selectedCategory: item.id });
              }}
            />
          </Grid.Column>
          {selectedCategory && (
            <Grid.Column width="3">
              <ReportsList
                onFavourite={this.onFavourite}
                reports={selectedCategory?.reports ?? []}
                title={`${selectedCategory?.name} Reports`}
                loading={loading}
                selected={this.state.report}
                onSelection={this.onSelection}
              />
            </Grid.Column>
          )}
          <Grid.Column width="10">
            {!this.state.report.id ? (
              <Segment.Group>
                <Segment>
                  <Header>Reports Viewer</Header>
                </Segment>
                <Segment>
                  Please choose a report on the left menu to begin.
                </Segment>
              </Segment.Group>
            ) : (
              <FormBuilder
                report={this.state.report}
                onError={this.onError}
                onChange={this.onParamsChange}
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default ReportsView;
